import { SVGProps } from '@components/Icon/types';

export const H2 = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1.0008, 5)">
      <path
        d="M12.9004 13.9905L12.9099 12.4667L18.9957 6.9905C19.5036 6.53336 19.8433 6.10161 20.0147 5.69526C20.1925 5.28256 20.2814 4.86034 20.2814 4.42859C20.2814 3.9016 20.1607 3.42541 19.9195 3.00001C19.6782 2.57461 19.348 2.2381 18.929 1.99048C18.5163 1.74286 18.0464 1.61905 17.5195 1.61905C16.9734 1.61905 16.4877 1.74921 16.0623 2.00953C15.6369 2.2635 15.3004 2.60318 15.0528 3.02858C14.8115 3.45398 14.694 3.91747 14.7004 4.41906H12.9671C12.9671 3.55557 13.1671 2.79366 13.5671 2.13334C13.9671 1.46667 14.5099 0.946035 15.1956 0.57143C15.8877 0.190476 16.6718 0 17.548 0C18.3988 0 19.1607 0.196826 19.8337 0.590477C20.5068 0.97778 21.0369 1.50794 21.4242 2.18096C21.8179 2.84763 22.0147 3.60319 22.0147 4.44764C22.0147 5.04446 21.9385 5.56193 21.7861 6.00002C21.6401 6.43812 21.4115 6.84447 21.1004 7.21907C20.7893 7.58733 20.3988 7.98098 19.929 8.40003L14.8718 12.9429L14.6528 12.3715H22.0147V13.9905H12.9004Z"
        fill={fill}
      />
      <path
        d="M0 14V0.285662H1.69524V6.3333H8.91432V0.285662H10.6096V14H8.91432V7.94283H1.69524V14H0Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'h2';
